exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3bMN686qBPYP1df9uC_kfN{text-align:center;padding:.3em;height:65px;background-color:#38346a;position:fixed;z-index:5;width:100%;top:0}._3bMN686qBPYP1df9uC_kfN span.hruLdVUnMhBPfEJjtzMC3{position:absolute;right:25px;top:5px;color:#fff;font-family:fira_sanslight,Arial;font-size:25px}._3bMN686qBPYP1df9uC_kfN span.hruLdVUnMhBPfEJjtzMC3 img{position:relative;width:45px;top:10px;right:10px}._3bMN686qBPYP1df9uC_kfN ._3ziz3YlSbXpUgiKHSIVb8g{font-size:40px;position:absolute;left:20px;top:16px;cursor:pointer;color:#fff}._3bMN686qBPYP1df9uC_kfN ._3ziz3YlSbXpUgiKHSIVb8g._1Z5Aqu0Zwn0qZCv7JWF_Hw,._3bMN686qBPYP1df9uC_kfN ._3ziz3YlSbXpUgiKHSIVb8g:hover{color:#82b0eb}._3bMN686qBPYP1df9uC_kfN img._3tQlvh1x4TPDTBa8ydlfmu{position:relative;top:12px;max-width:58%}img.D_wEYfHRA_-9PPzdp5cvv{border-radius:8px;border:2px solid #82b0eb;box-sizing:border-box}@media screen and (max-width:900px){._3bMN686qBPYP1df9uC_kfN{height:40px}._3bMN686qBPYP1df9uC_kfN span.hruLdVUnMhBPfEJjtzMC3{right:12px}._3bMN686qBPYP1df9uC_kfN span.hruLdVUnMhBPfEJjtzMC3 span{display:none}._3bMN686qBPYP1df9uC_kfN span.hruLdVUnMhBPfEJjtzMC3 img{width:35px;top:2px}._3bMN686qBPYP1df9uC_kfN ._3ziz3YlSbXpUgiKHSIVb8g{font-size:40px;top:5px}._3bMN686qBPYP1df9uC_kfN img._3tQlvh1x4TPDTBa8ydlfmu{max-width:36%;top:7px}}", ""]);

// exports
exports.locals = {
	"header": "_3bMN686qBPYP1df9uC_kfN",
	"username": "hruLdVUnMhBPfEJjtzMC3",
	"menuIcon": "_3ziz3YlSbXpUgiKHSIVb8g",
	"active": "_1Z5Aqu0Zwn0qZCv7JWF_Hw",
	"titleImage": "_3tQlvh1x4TPDTBa8ydlfmu",
	"avatar": "D_wEYfHRA_-9PPzdp5cvv"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Header/Header.scss
 ** module id = 298
 ** module chunks = 0
 **/